import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  stickyHeader: {
    backgroundColor: '#f8f8f8',
  },
}));

export default useStyles;
